import { http, queryString } from 'utils'
import { PaymentDecorator } from 'decorators'
import { map, omit, concat } from 'lodash'

// Payment mutation imports.
import {
  SET_PAYMENTS, SET_PAYMENTS_PAGINATION, ADD_PAYMENTS, SET_PAYMENT, RESET_PAYMENT
} from 'vx/mutations'

const initialPaymentState = () => {
  return {
    id: null,
    carrier_id: null,
    xero_number: null
  }
}
// Payment state.
const state = {
  payments: [],
  payment: initialPaymentState()
}

// Payment state getters.
const getters = {
  /**
   * Payments decorated via the PaymentsDecorator.
   */
  paymentsDecorated: state => map(state.payments, payment => (new PaymentDecorator(payment))),

  /**
   * Decorated payment.
   */
  paymentDecorated: state => (new PaymentDecorator(state.payment))
}

// Payment actions.
const actions = {
  /**
   * Get a list of payments based on user.
   */
  getPayments ({ commit }, payload) {
    return http.get(`payments?${queryString(payload)}`).then(response => {
      commit(SET_PAYMENTS, response.data.data)
      commit(SET_PAYMENTS_PAGINATION, omit(response.data, 'data'))

      return response
    })
  },

  /**
   * Get the payments for the next page.
   */
  getPaymentsForNextPage ({ commit, state }, payload) {
    if (state.pagination.current_page === state.pagination.last_page || state.pagination.total === 0) {
      return Promise.reject('There are no more payments to load.')
    }

    let page = state.pagination.current_page + 1

    return http.get(`payments?${queryString(payload)}&page=${page}`).then(response => {
      commit(ADD_PAYMENTS, response.data.data)
      commit(SET_PAYMENTS_PAGINATION, omit(response.data, 'data'))

      return response
    })
  },

  /**
   * Get payment by id
   */
  getPayment ({ commit }, id) {
    return http.get(`payments/${id}`).then(response => {
      commit(SET_PAYMENT, response.data)

      return response
    })
  },

  /**
   * Sync payment by id
   */
  syncPayment ({ commit }, id) {
    return http.post(`payments/${id}/sync`)
  },

  /**
   * Get payment by public id
   */
  getPaymentByPublicId ({ commit }, id) {
    return http.get(`payments/${id}/public`).then(response => {
      commit(SET_PAYMENT, response.data)

      return response
    })
  },

  /**
   * Upload an invoice for a payment.
   */
  uploadPaymentInvoice ({ commit }, { id, file, number }) {
    let payload = new FormData()

    if (file) {
      payload.append('file', file)
    }

    payload.append('number', number)

    return http.post(`payments/${id}/invoice`, payload)
  }
}

// Payment state mutations.
const mutations = {
  /**
   * Set the payments.
   */
  [SET_PAYMENTS] (state, payments) {
    state.payments = payments
  },

  /**
   * Set the driver pagination.
   */
  [SET_PAYMENTS_PAGINATION] (state, pagination) {
    state.pagination = pagination
  },

  /**
   * Add more payments to the payments state.
   */
  [ADD_PAYMENTS] (state, payments) {
    state.payments = concat(state.payments, payments)
  },

  /**
   * Add more invoices to the invoices state.
   */
  [SET_PAYMENT] (state, payment) {
    state.payment = payment
  },

  /**
   * Reset the load.
   */
  [RESET_PAYMENT] (state) {
    state.payment = initialPaymentState()
  }
}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/payment.js